/**
 * 全局配置文件
 * 根据环境自动切换API地址
 */

// 获取API基础URL
const getApiBaseUrl = () => {
  // Vue CLI 项目使用 process.env.VUE_APP_API_BASE_URL
  // 在生产环境构建时，这个值会被替换为 .env.production 中的值
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }
  // 默认值（开发环境）- 使用空字符串让请求通过前端代理
  return ''
}

// 获取前端基础URL
const getBaseUrl = () => {
  // Vue CLI 项目使用 process.env.VUE_APP_BASE_URL
  if (process.env.VUE_APP_BASE_URL) {
    return process.env.VUE_APP_BASE_URL
  }
  // 默认值（开发环境）
  return 'http://127.0.0.1:8081'
}

// 判断是否为开发环境
const isDevelopment = () => {
  return process.env.NODE_ENV === 'development'
}

// 判断是否为生产环境
const isProduction = () => {
  return process.env.NODE_ENV === 'production'
}

const config = {
  // API 基础地址（后端）
  API_BASE_URL: getApiBaseUrl(),

  // 前端基础地址
  BASE_URL: getBaseUrl(),

  // 环境标识
  isDev: isDevelopment(),
  isProd: isProduction(),

  // 请求超时时间（毫秒）
  timeout: 15000,

  // Token 存储键名
  TOKEN_KEY: 'token',
  USER_INFO_KEY: 'userInfo',
  
  // 系统配置
  systemConfig: {
    // 聊天记录配置
    chat: {
      expireDays: 30, // 聊天记录保存时间（天），默认30天
    },
    // 其他配置
    upload: {
      maxFileSize: 100 * 1024 * 1024, // 100MB
      timeout: 600000, // 10分钟
    },
  },
  
  // 存储键前缀
  storageKeys: {
    chatHistory: 'pzwh_chat_history_',
    token: 'token',
    userInfo: 'userInfo',
  },
}

export default config
